var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 68.357 47.522 c -0.828 0 -1.5 -0.672 -1.5 -1.5 V 3 h -44.85 v 41.949 c 0 0.829 -0.671 1.5 -1.5 1.5 s -1.5 -0.672 -1.5 -1.5 V 1.5 c 0 -0.829 0.671 -1.5 1.5 -1.5 h 47.85 c 0.828 0 1.5 0.671 1.5 1.5 v 44.522 C 69.857 46.851 69.186 47.522 68.357 47.522 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 86.699 30.081 c 0 -0.164 -0.035 -0.321 -0.086 -0.472 c -0.014 -0.041 -0.032 -0.079 -0.049 -0.119 c -0.062 -0.144 -0.143 -0.277 -0.247 -0.395 c -0.012 -0.014 -0.016 -0.032 -0.029 -0.046 c -0.004 -0.004 -0.01 -0.005 -0.014 -0.01 c -0.096 -0.099 -0.204 -0.187 -0.326 -0.258 l -16.842 -9.728 c -0.717 -0.415 -1.635 -0.17 -2.049 0.549 c -0.414 0.717 -0.169 1.635 0.549 2.049 l 15.1 8.722 L 51.427 59.982 l -5.498 -4.332 c -0.545 -0.428 -1.313 -0.428 -1.856 0 l -5.498 4.332 L 7.292 30.374 l 13.965 -8.066 c 0.718 -0.414 0.963 -1.332 0.549 -2.049 c -0.414 -0.717 -1.331 -0.964 -2.049 -0.549 L 4.051 28.782 c -0.123 0.071 -0.231 0.16 -0.327 0.259 c -0.004 0.004 -0.009 0.005 -0.012 0.009 C 3.7 29.062 3.697 29.078 3.686 29.09 c -0.106 0.12 -0.188 0.256 -0.252 0.403 c -0.017 0.039 -0.034 0.075 -0.047 0.114 c -0.051 0.152 -0.086 0.309 -0.086 0.474 V 88.5 c 0 0.018 0.005 0.035 0.005 0.052 c 0.002 0.054 0.008 0.107 0.016 0.16 c 0.007 0.046 0.013 0.091 0.023 0.135 c 0.011 0.048 0.028 0.095 0.044 0.142 c 0.016 0.047 0.032 0.093 0.053 0.137 c 0.019 0.042 0.043 0.082 0.067 0.123 c 0.027 0.046 0.053 0.09 0.085 0.133 c 0.011 0.015 0.018 0.032 0.029 0.046 c 0.018 0.023 0.04 0.04 0.059 0.061 c 0.035 0.039 0.07 0.077 0.109 0.113 c 0.035 0.032 0.07 0.061 0.107 0.089 c 0.041 0.031 0.083 0.06 0.126 0.087 c 0.039 0.023 0.078 0.044 0.118 0.064 c 0.047 0.023 0.096 0.044 0.146 0.063 c 0.041 0.015 0.082 0.027 0.124 0.039 c 0.051 0.014 0.102 0.025 0.155 0.034 c 0.047 0.007 0.093 0.011 0.14 0.014 C 4.74 89.993 4.769 90 4.801 90 h 80.398 c 0.109 0 0.215 -0.013 0.318 -0.035 c 0.026 -0.006 0.05 -0.016 0.075 -0.023 c 0.077 -0.021 0.152 -0.045 0.223 -0.077 c 0.034 -0.015 0.065 -0.035 0.098 -0.053 c 0.06 -0.033 0.118 -0.067 0.173 -0.107 c 0.034 -0.025 0.065 -0.052 0.097 -0.08 c 0.05 -0.044 0.097 -0.091 0.141 -0.141 c 0.017 -0.019 0.038 -0.034 0.054 -0.054 c 0.012 -0.016 0.02 -0.034 0.031 -0.05 c 0.029 -0.039 0.054 -0.081 0.078 -0.123 c 0.026 -0.044 0.051 -0.087 0.072 -0.132 c 0.019 -0.041 0.034 -0.084 0.049 -0.127 c 0.018 -0.05 0.035 -0.1 0.047 -0.151 c 0.01 -0.042 0.015 -0.084 0.022 -0.127 c 0.008 -0.056 0.015 -0.112 0.017 -0.168 c 0.001 -0.017 0.005 -0.033 0.005 -0.05 V 30.081 z M 83.699 33.566 v 51.841 l -29.89 -23.549 L 83.699 33.566 z M 45 58.738 L 80.871 87 H 9.129 L 45 58.738 z M 6.301 85.408 V 33.566 l 29.89 28.293 L 6.301 85.408 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 13.496 c -9.296 0 -16.859 7.563 -16.859 16.859 S 35.704 47.214 45 47.214 c 0.829 0 1.5 -0.672 1.5 -1.5 c 0 -0.829 -0.671 -1.5 -1.5 -1.5 c -7.642 0 -13.859 -6.217 -13.859 -13.859 S 37.358 16.496 45 16.496 s 13.858 6.217 13.858 13.859 c 0.001 2.487 -0.376 6.682 -2.808 6.838 c -0.747 0 -3.019 0 -3.019 -4.819 V 28.32 c 0 -0.829 -0.672 -1.5 -1.5 -1.5 s -1.5 0.671 -1.5 1.5 v 4.054 c 0 1.657 -1.348 3.005 -3.005 3.005 h -4.055 c -1.657 0 -3.005 -1.348 -3.005 -3.005 V 28.32 c 0 -1.657 1.348 -3.005 3.005 -3.005 h 4.055 c 0.828 0 1.5 -0.671 1.5 -1.5 s -0.672 -1.5 -1.5 -1.5 h -4.055 c -3.311 0 -6.005 2.694 -6.005 6.005 v 4.054 c 0 3.311 2.694 6.005 6.005 6.005 h 4.055 c 1.484 0 2.841 -0.544 3.89 -1.438 c 1.407 2.931 4.115 3.25 5.216 3.25 c 0.004 0 0.009 0 0.012 0 c 2.135 -0.134 5.716 -1.591 5.714 -9.836 C 61.858 21.059 54.296 13.496 45 13.496 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/Mail.b90e8dee4ca0020121d5f2ba0c60cac8.svg";
export { ForwardRef as ReactComponent };